import { Route, Switch, Redirect } from 'react-router-dom';

import RedemptionsPage from 'features/redemptions/pages/RedemptionsPage';

import { rootPaths } from 'routes/paths';
import { redemptionsPaths } from 'features/redemptions/routes/paths';
import { Title } from 'shared';
import { useTranslation } from 'hooks/useTranslation';

export const RedemptionsRouter = () => {
  const { t } = useTranslation('app');

  return (
    <>
      <Title title={t('redemptions')} />
      <Switch>
        <Route exact path={redemptionsPaths.static.root} component={RedemptionsPage} />
        <Route>
          <Redirect to={rootPaths.static.notFound} />
        </Route>
      </Switch>
    </>
  );
};
